import React from 'react';
import Container from '../../shared/Container';
import { ParagraphCollectionRenderer } from '../../tileRenderers/ParagraphCollectionRenderer/ParagraphCollectionRenderer';
import { BlogRichtextTile } from './types/BlogRichtextTile';
import './styles.css';
import { twJoin } from 'tailwind-merge';

export default function BlogRichtext({ tile }: { tile: BlogRichtextTile }) {
  const fontSize = tile['font-size']?.options?.[0].value;
  const maxWidth = tile['max-width']?.options?.[0].value;
  const removeBlockMargins = tile['remove-block-margins']?.value;
  const removeParagraphMargins = tile['remove-paragraph-margins']?.value;

  let maxWidthClasses = '';
  switch (maxWidth) {
    case '4xl':
      maxWidthClasses = 'max-w-4xl';
      break;
    case '5xl':
      maxWidthClasses = 'max-w-5xl';
      break;
    case '6xl':
      maxWidthClasses = 'max-w-6xl';
      break;
    case '7xl':
      maxWidthClasses = 'max-w-7xl';
      break;
    default:
      maxWidthClasses = 'max-w-4xl';
  }

  return (
    <Container className={twJoin(removeBlockMargins && 'my-0 sm:my-0 lg:my-0')}>
      <div
        className={twJoin('blog-richtext mx-auto', maxWidthClasses)}
        style={{
          fontSize: fontSize ? `${fontSize}` : undefined,
        }}
      >
        <ParagraphCollectionRenderer
          removeParagraphMargins={removeParagraphMargins}
          content={tile['extended-text']}
        />
      </div>
    </Container>
  );
}
